module.exports = __webpack_public_path__ + "static/media/icon_bandAid.1d497aca.svg";